/**
 * Copyright (c) 2022 Cedalo GmbH
 */
 import React from 'react';
 import { useParams } from 'react-router-dom';
 import * as AccountDelegate from './AccountDelegate';
 import { AccountsPage } from '../components/accounts/AccountsPage';
 
 export function AccountPage() {
	 const { accountId } = useParams();
 
	 return <AccountsPage accountId={accountId} delegate={AccountDelegate} breadcrumbsPath="Home/Accounts" />;
 }
 